import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const createdWorkshop = (payload) => AxiosClient.post('/workshop', payload);
const updateWorkshop = (id, payload) => AxiosClient.put(`/workshop/${id}`, payload);
const getWorkshopList = (query) => AxiosClient.get('/workshop', { ...query });
const deleteWorkshop = (id, payload) => AxiosClient.delete(`/workshop/${id}`);
const createdAttendance = (payload) => AxiosClient.post('/attendance', payload);
const updateAttendance = (id, payload) => AxiosClient.put(`/attendance/${id}`, payload);
const getAttendanceList = (query) => AxiosClient.get('/attendance', { ...query });
const downloadAttendanceList = (query) => AxiosClient.get('/attendance/download-excel', { ...query }, { responseType: 'arraybuffer' });


export {
    createdWorkshop,
    getWorkshopList,
    updateWorkshop,
    deleteWorkshop,
    createdAttendance,
    updateAttendance,
    getAttendanceList,
    downloadAttendanceList
}